import { render, staticRenderFns } from "./AutoDMListPage.vue?vue&type=template&id=f135dcd8&"
import script from "./AutoDMListPage.vue?vue&type=script&lang=js&"
export * from "./AutoDMListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports